module.exports = __webpack_public_path__ + "assets/img/Type BS (6).fef81aae.jpg";